import { apiClient, apiGet, apiPost, apiPut, apiDelete } from "@/lib/api/client";
import type { PaginatedParams, PaginatedResponse } from "@/lib/api/types";

const BASE = "/reports";

export const reportsApi = {
  list: (params?: PaginatedParams & { type?: string; status?: string }) => {
    const searchParams = new URLSearchParams();
    if (params?.page) searchParams.set("page", String(params.page));
    if (params?.perPage) searchParams.set("perPage", String(params.perPage));
    if (params?.type) searchParams.set("type", params.type);
    if (params?.status) searchParams.set("status", params.status);
    return apiGet<PaginatedResponse<Record<string, unknown>>>(`${BASE}?${searchParams.toString()}`);
  },

  getById: (id: string) => apiGet<{ report: Record<string, unknown> }>(`${BASE}/${id}`),

  create: (data: Record<string, unknown>) => apiPost<{ report: Record<string, unknown> }>(BASE, data),

  update: (id: string, data: Record<string, unknown>) =>
    apiPut<{ report: Record<string, unknown> }>(`${BASE}/${id}`, data),

  delete: (id: string) => apiDelete<{ message: string }>(`${BASE}/${id}`),

  export: (format: string, params?: Record<string, unknown>) =>
    apiPost<{ url: string }>(`${BASE}/export`, { format, ...params }),
};
